import React from 'react';
import { Instagram, Youtube, Mail, ExternalLink } from 'lucide-react';
import { influencerData } from '../mock';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-black bg-gradient-to-r from-[#00ff41] to-[#ff6b35] bg-clip-text text-transparent mb-4">
              ALEX MORGAN
            </h3>
            <p className="text-gray-400 mb-4 max-w-sm">
              Fitness content creator helping brands convert audiences into paying customers through authentic, high-performance content.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-900 border border-gray-800 flex items-center justify-center hover:border-[#00ff41] hover:bg-[#00ff41]/10 transition-all"
              >
                <Instagram size={20} className="text-gray-400 hover:text-[#00ff41]" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-900 border border-gray-800 flex items-center justify-center hover:border-[#ff6b35] hover:bg-[#ff6b35]/10 transition-all"
              >
                <Youtube size={20} className="text-gray-400 hover:text-[#ff6b35]" />
              </a>
              <a
                href="mailto:alex@example.com"
                className="w-10 h-10 rounded-full bg-gray-900 border border-gray-800 flex items-center justify-center hover:border-[#00ff41] hover:bg-[#00ff41]/10 transition-all"
              >
                <Mail size={20} className="text-gray-400 hover:text-[#00ff41]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('content')}
                  className="text-gray-400 hover:text-[#00ff41] transition-colors"
                >
                  Content
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('brands')}
                  className="text-gray-400 hover:text-[#00ff41] transition-colors"
                >
                  Brands
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#00ff41] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-[#00ff41] transition-colors"
                >
                  Results
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Sponsored Content</li>
              <li className="text-gray-400">UGC for Ads</li>
              <li className="text-gray-400">Fitness Programs</li>
              <li className="text-gray-400">Brand Ambassador</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Alex Morgan Fitness. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-500 hover:text-[#00ff41] transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-[#00ff41] transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
